import { Component, Input } from '@angular/core';
import { AppRoutesEnum } from '@app/routes';

@Component({
    selector: 'ins-knowledgebase-article-cards',
    templateUrl: './knowledgebase-article-cards.component.html',
})
export class KnowledgebaseArticleCardsComponent {
    @Input() knowledgeBaseItems = [];
    @Input() columns: 2 | 3 | 4 = 2;

    public appRoutesEnum = AppRoutesEnum;

}
